module.exports = __webpack_public_path__ + "static/media/05 Fuji Duck.7d2c23ee.webp";